module.exports = __webpack_public_path__ + "static/media/chalkboard_empty.60afa441.jpg";